import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'step1',
      component: () => import('@/page/step1'),
    },
    {
      path: '/step2',
      name: 'step2',
      component: () => import('@/page/step2'),
    },
    {
      path: '/step3',
      name: 'step3',
      component: () => import('@/page/step3'),
    },
    {
      path: '/over',
      name: 'over',
      component: () => import('@/page/over'),
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js